import React from "react";
import { RCCBadge, RCCGrid, RCCInput } from "react-common-components";
import Select from "src/components/Select";
import { useTranslation } from "src/context/Translations/context";
import { IItemList, IPeriodType } from "./interface";
import { LineListFields, StyledSpan } from "./styles";


const ItemList: React.FC<IItemList> = ({
	data,
	fieldsName,
	index,
	control,
	register,
	clickField,
	selected,
	showOnlyDescription
}) => {

	const { translate } = useTranslation();

	const [periodSelected, setPeriodSelected] = React.useState<IPeriodType>(IPeriodType.CURRENT);
	const [numberPeriods, setNumberPeriods] = React.useState(0);

	return (
		<>
			<LineListFields className="list-component-child">
				<RCCGrid
					item
					container
					alignItems="center"
					xs={showOnlyDescription ? 12 : 6}
					justifyContent="flex-start"
				>
					<RCCBadge
						onClick={() => clickField(data.iqb001Id, data.iqb001Codigo, data.iqb001Label, periodSelected, numberPeriods)}
						layout="isSquare"
						color={selected ? "blue" : "grey"}
					>
						<StyledSpan>
							{`${data.iqb001Label} (${data.iqb001Codigo})`}
						</StyledSpan>
					</RCCBadge>
				
				</RCCGrid>
				{showOnlyDescription !== true && (
					<>
						<RCCGrid
							item
							container
							alignItems="center"
							xs={2}
							justifyContent="flex-start"
						>
							<StyledSpan>
								{data.iqb001Meta === "N" ? translate("Não") : translate("Sim")}
							</StyledSpan>
						</RCCGrid>
						<RCCGrid
							item
							container
							alignItems="center"
							xs={2}
							justifyContent="flex-start"
							style={{ paddingRight: "3px" }}					
						>
							<Select
								control={control}
								name={`${fieldsName}[${index}].daysPast`} 
								options={[
									{ value: IPeriodType.CURRENT, label: translate("Atual") },
									{ value: IPeriodType.BACK, label: translate("Anterior") },
									{ value: IPeriodType.FORWARD, label: translate("Posterior") }
								]}
								onChangeCapture={(e) => {   
									if(e.value === IPeriodType.BACK){
										setPeriodSelected(IPeriodType.BACK);
										return;
									}
									if(e.value === IPeriodType.FORWARD){
										setPeriodSelected(IPeriodType.FORWARD);	
										return;
									}
									if(e.value === IPeriodType.CURRENT) {
										setPeriodSelected(IPeriodType.CURRENT);	
									}
								}}
								layout="outlined"	
								defaultValue={IPeriodType.CURRENT}
								styleInline="min-height: unset;padding-top: 0px;"		
							/>
						</RCCGrid>
						<RCCGrid
							item
							container
							alignItems="center"
							xs={2}
							justifyContent="flex-start"
							style={{ paddingLeft: "3px" }}	
						>
							<RCCInput 
								register={register}
								name={`${fieldsName}[${index}].daysPost`}
								onClick={(e) => e.stopPropagation()} 
								disabled={periodSelected === IPeriodType.CURRENT}
								type="number" 
								label=""		
								layout="outlined"	
								onKeyPress={(event) => {
									if (!/[0-9]/.test(event.key)) {
										event.preventDefault();
									}
								}}
								onChange={(e) => {
									setNumberPeriods(parseInt(e.target.value, 10));
								}}
								min={0}
								defaultValue={0}
								styleInline="height: 34px; input {padding: 0px 2px 0 15px !important;}"						
							/>
						</RCCGrid>
					</>
				)}
								
			</LineListFields>	
		</>
	);

};

export default ItemList;
